module.exports = __webpack_public_path__ + "static/media/firefox_logo.8a4efb48.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/firefox_logo.png
// module id = 1296
// module chunks = 33